import React, { forwardRef } from 'react';

import MUIFormHelperText, {
  FormHelperTextProps as MUIFormHelperTextProps,
} from '@material-ui/core/FormHelperText';

interface FormHelperTextProps extends MUIFormHelperTextProps {}

const FormHelperText = forwardRef<HTMLParagraphElement, FormHelperTextProps>(
  (props, ref) => {
    return <MUIFormHelperText {...props} ref={ref} />;
  }
);

FormHelperText.displayName = 'FormHelperText';

export default FormHelperText;
